import React, {useEffect, useRef, useState} from 'react'
import {Stack} from 'react-bootstrap'
import defaultImage from '../../../_metronic/images/uploadImageIcon.svg'
import {BUCKET_NAME} from '../../../utils/config'
import ResetPassword from './ResetPassword'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {
  GET_USER_PROFILE,
  GETSIGNEDURLFORUPLOAD,
  S3_FILE_DELETE,
  UPDATE_USER_PROFILE,
} from '../../../utils/GraphQLAPI'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import TextField from '../TextField/TextField'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './UserProfile.css'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'

const MySwal = withReactContent(Swal)
const networkOnly = 'network-only'

const initialValues = {
  avatarUrl: '',
  firstName: '',
  lastName: '',
  emailId: '',
  teamName: '',
  salesChannel: '',
}
const SpecialChar = 'Special characters not allowed'
const enrollSchema = Yup.object().shape({
  // avatarUrl:
  firstName: Yup.string()
    .required('First name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, SpecialChar)
    .min(3, "First name shouldn't less than 3 characters")
    .max(40, "First name shouldn't exceed 40 characters")
    .nullable(),
  lastName: Yup.string()
    // .required('Last name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, SpecialChar)
    .nullable(),
  // .max(40, "Last name shouldn't exceed 40 characters"),
  emailId: Yup.string()
    .required('Email ID is required')
    .email('Email ID is not Valid')
    .matches(/^(?!.*@[^,]*,)/, 'Email ID is not Valid')
    .min(10, "Email ID shouldn't less than 10 characters")
    .max(40, "Email ID shouldn't exceed 40 characters")
    .nullable(),
  salesChannel: Yup.string()
    // .required('Sales Channel is required')
    .matches(/^[0-9a-zA-Z \b]+$/, SpecialChar)
    .min(3, "Channel Name shouldn't less than 3 characters")
    .max(40, "Channel Name shouldn't exceed 40 characters")
    .nullable(),
  teamName: Yup.string()
    // .required('Team name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, SpecialChar)
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "Team name shouldn't less than 3 characters")
    .max(40, "Team name shouldn't exceed 40 characters")
    .nullable(),
})

const UserProfile = () => {
  const [uploadFileName, setUploadFileName] = useState<any>('')
  const fileInputRef = useRef<any>()
  const [btnShow, setBtnShow] = useState<boolean>(false)
  const [textShow, setTextShow] = useState<boolean>(false)
  const [userRole, setUserRole] = useState<any>('')
  const [image, setImage] = useState<File | null>()
  const [imageUrl, setImageUrl] = useState<any>()
  const [preview, setPreview] = useState<any>()
  const [data, setData] = useState<any>('')
  const [isDisabled, setIsDisabled] = useState<boolean>(true)
  const [fileError, setFileError] = useState<any>('')
  const [editMode, setEditMode] = useState<boolean>(false)
  const [deleteCall, setDeleteCall] = useState<boolean>(false)

  const handleEdit = () => {
    setBtnShow(true)
    setTextShow(true)
    setEditMode(true)
    setIsDisabled(false)
    formik.setFieldValue('avatarUrl', data?.getUserProfile?.avatarUrl)
  }

  const handleDiscard = () => {
    setImage(null)
    setBtnShow(false)
    setTextShow(false)
    setIsDisabled(true)
    setEditMode(false)
    setFileError('')
    setPreview(data?.getUserProfile?.avatarUrl)
    formik.setErrors({
      avatarUrl: '',
      firstName: '',
      lastName: '',
      emailId: '',
      teamName: '',
      salesChannel: '',
    })
    formik.resetForm()
    getUserProfile()
    formik.setFieldValue('avatarUrl', data?.getUserProfile?.avatarUrl)
  }

  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }

  // Fetch User Data
  const [getUserProfile] = useLazyQuery(GET_USER_PROFILE, {
    fetchPolicy: networkOnly,
    variables: {
      getEntityName: true,
    },
    onCompleted: async (userData) => {
      window.localStorage.setItem('userId', JSON.stringify(userData?.getUserProfile?.id))
      const userDetails = {
        avatarUrl: userData?.getUserProfile?.avatarUrl,
        firstName: userData?.getUserProfile?.firstName,
        lastName: userData?.getUserProfile?.lastName,
        emailId: userData?.getUserProfile?.emailId,
        salesChannel:
          userData?.getUserProfile?.members[0]?.role === 'SALES_ADMIN' || 'AGENT'
            ? userData?.getUserProfile?.members[0]?.entityName
            : null,
        teamName:
          userData?.getUserProfile?.members[0]?.role === 'SYSTEM_ADMIN' || 'QC_USER'
            ? userData?.getUserProfile?.members[0]?.entityName
            : null,
      }
      formik.setValues({...userDetails})
      setData(userData)

      if (userData.getUserProfile.userRole === 'TPV_ADMIN') {
        setUserRole('TPV Admin')
      } else if (userData.getUserProfile.userRole === 'USER') {
        if (userData.getUserProfile.members[0].role === 'AGENT') {
          setUserRole('Agent Admin')
        } else if (userData.getUserProfile.members[0].role === 'SALES_ADMIN') {
          setUserRole('Sales Admin')
        } else if (userData.getUserProfile.members[0].role === 'SYSTEM_ADMIN') {
          setUserRole('System Admin')
        } else if (userData.getUserProfile.members[0].role === 'QC_USER') {
          setUserRole('QC User')
        }
      }
    },
  })

  useEffect(() => {
    getUserProfile()
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      updateUserProfile({
        variables: {
          updateUserInput: {
            firstName: values.firstName,
            lastName: values.lastName,
            avatarUrl: deleteCall && imageUrl == '' ? null : imageUrl,
          },
        },
      })
    },
  })

  // Update
  const [updateUserProfile] = useMutation(UPDATE_USER_PROFILE, {
    onCompleted: (detail) => {
      if (detail.updateUserProfile.id) {
        if (deleteCall) {
          ;(async () => {
            const response = await deleteProfile({
              variables: {
                key: data?.getUserProfile?.avatarUrl,
                bucketName: BUCKET_NAME,
              },
            })
            if (response) {
              setDeleteCall(false)
            }
          })()
        }

        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Profile Updated Successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in updating profile',
        })
      }
      handleDiscard()
    },
    onError: (e) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  useEffect(() => {
    if (image) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreview(reader.result as string)
      }
      reader.readAsDataURL(image)
    }
  }, [])

  useEffect(() => {
    data?.getUserProfile?.avatarUrl
      ? setPreview(process.env.REACT_APP_IMAGE_BASE_URL + data?.getUserProfile?.avatarUrl)
      : setPreview(defaultImage)
    if (image) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreview(reader.result as string)
      }
      reader.readAsDataURL(image)
    }
  }, [data, image])

  const {
    loading: urlLoading,
    data: urlData,
    refetch: urlRefetch,
  } = useQuery(GETSIGNEDURLFORUPLOAD, {
    skip: uploadFileName.length > 0 ? false : true,
    variables: {
      key: uploadFileName,
      bucketName: BUCKET_NAME,
    },
  })

  const handleUploadImage = async (event: React.ChangeEvent<any>) => {
    const nativeEvent = event.nativeEvent.target as HTMLInputElement
    const file = event.target.files[0]
    nativeEvent.value = ''

    const allowedImageType = ['image/png', 'image/jpg', 'image/jpeg']
    if (!allowedImageType.includes(file.type)) {
      setFileError('Sorry, you can only upload a .JPG, .JPEG .PNG file')
      return
    }
    // checking for image types
    if (file && file.type.substr(0, 5) === 'image') {
      const imagesformat = file.name.replace(/\s+/g, '-')
      const imageFileName = imagesformat.split('.').join(`-${Date.now()}.`)
      setUploadFileName(`images/${imageFileName}`)
      setImage(file)
      setFileError('')
    } else {
      setImage(null)
      setFileError('')
    }
  }

  const fileUploadToS3 = (objectUrl: any) => {
    if (objectUrl) {
      fetch(objectUrl, {
        method: 'PUT',
        headers: {'Content-Type': 'image/*'},
        body: image,
      }).then((response) => {
        if (response && response.url) {
          const bucketUrl = response.url.split('?')[0]
          setImageUrl(bucketUrl.split('com/')[1])
        }
      })
    }
  }

  useEffect(() => {
    if (!urlLoading && uploadFileName.length > 0) {
      if (urlData) {
        setUploadFileName('')
        fileUploadToS3(urlData.getSignedUrlForUpload.preSignedUrl)
        setDeleteCall(false)
      } else {
        urlRefetch()
      }
    }
  }, [uploadFileName, fileUploadToS3])

  const [deleteProfile, {loading: reload}] = useLazyQuery(S3_FILE_DELETE, {
    fetchPolicy: 'network-only',
    variables: {
      key: data?.getUserProfile?.avatarUrl,
      bucketName: BUCKET_NAME,
    },
    onCompleted: () => {
      setDeleteCall(false)
    },
  })

  const deleteS3Object = async () => {
    setPreview(defaultImage)
    setImageUrl('')
    setDeleteCall(true)
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <Breadcrumbs title='My Account' subTitle='Home - User Profile' />
      </div>

      <div className='card'>
        <div className='card-body'>
          <div className='row border-bottom mb-3'>
            <div className='col-6'>
              <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
                <span className='fs-2 fw-bolder text-gray-900'>Profile Details</span>
              </label>
            </div>
            <div className='col-6 text-end'>
              <button
                type='button'
                className={`btn btn-primary text-white btn-active-color-primary btn-md me-1 ${
                  btnShow ? 'd-none' : null
                }`}
                onClick={() => handleEdit()}
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                style={{
                  position: 'absolute',
                  right: '20px',
                  top: '15px',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Edit
              </button>
            </div>
          </div>
          <form noValidate id='kt_modal_create_app_form' onSubmit={formik.handleSubmit}>
            <div className='row mt-1'>
              <div className='col-lg-12'>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23px'>Profile Avatar</span>
                </label>
                <Stack direction='horizontal' gap={1}>
                  <div>
                    {!urlLoading && !reload ? (
                      <Stack direction='horizontal' gap={3}>
                        <div style={{position: 'relative'}}>
                          {preview ? (
                            <>
                              <input
                                type='image'
                                src={preview}
                                alt='Loading'
                                width='128'
                                height='128'
                                disabled={isDisabled}
                                style={{position: 'relative'}}
                                onClick={(event) => {
                                  event.preventDefault()
                                  fileInputRef.current.click()
                                }}
                              />
                              {data?.getUserProfile?.avatarUrl !== null &&
                                data?.getUserProfile?.avatarUrl !== '' &&
                                editMode &&
                                deleteCall == false && (
                                  <label
                                    onClick={() => deleteS3Object()}
                                    className={`btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow ${
                                      isDisabled && 'disabled'
                                    }`}
                                    data-kt-image-input-action='change'
                                    data-bs-toggle='tooltip'
                                    aria-label='Change avatar'
                                    data-bs-original-title='Change avatar'
                                    data-kt-initialized='1'
                                    style={{position: 'absolute', top: '-10px', right: '-12px'}}
                                  >
                                    <svg
                                      width='12'
                                      height='12'
                                      viewBox='0 0 20 20'
                                      fill='none'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <g clip-path='url(#clip0_22658_81815)'>
                                        <path
                                          opacity='0.5'
                                          d='M10 8.23254L8.2326 9.99997L0.36628 17.8655C-0.122021 18.3538 -0.122021 19.1455 0.36628 19.6338C0.854542 20.1221 1.64623 20.1221 2.13453 19.6338L10 11.7674L11.7675 9.99997L19.6338 2.13447C20.1221 1.64621 20.122 0.854526 19.6338 0.366225C19.1455 -0.122075 18.3538 -0.122075 17.8655 0.366225L10 8.23254Z'
                                          fill='currentColor'
                                        />
                                        <path
                                          d='M9.99997 8.23254L11.7674 9.99997L19.6337 17.8655C20.122 18.3538 20.122 19.1455 19.6337 19.6338C19.1455 20.1221 18.3538 20.1221 17.8655 19.6338L9.99997 11.7674L8.23254 9.99997L0.366225 2.13447C-0.122075 1.64621 -0.122036 0.854526 0.366225 0.366225C0.854487 -0.122075 1.64617 -0.122075 2.13447 0.366225L9.99997 8.23254Z'
                                          fill='currentColor'
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id='clip0_22658_81815'>
                                          <rect width='20' height='20' fill='currentColor' />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </label>
                                )}
                            </>
                          ) : (
                            <input
                              src={defaultImage}
                              alt='default img'
                              type='image'
                              width='128'
                              height='128'
                              style={{position: 'relative'}}
                              disabled={isDisabled}
                              onClick={(event) => {
                                event.preventDefault()
                                fileInputRef.current.click()
                              }}
                            />
                          )}
                          <input
                            type='file'
                            className='d-none'
                            style={{position: 'relative'}}
                            ref={fileInputRef}
                            accept='image/png,image/jpg,image/jpeg'
                            onChange={(event: any) => handleUploadImage(event)}
                          />
                        </div>
                        <div>
                          <span
                            className={`fs-6 text-grey-400 text-muted ${
                              textShow ? null : 'd-none'
                            }`}
                          >
                            Allowed file types:
                            <br />
                            png,jpg,jpeg.
                          </span>
                          <div className='fv-plugins-message-container'>
                            <div
                              data-field='appname'
                              data-validator='notEmpty'
                              className='fv-help-block'
                            >
                              {fileError}
                            </div>
                          </div>
                        </div>
                      </Stack>
                    ) : (
                      <>
                        <input
                          type='image'
                          src={preview}
                          alt='preview'
                          width='128'
                          height='128'
                          disabled={true}
                          className='imageBlur'
                        />
                        <span className='indicator-progress img-spinner' style={{display: 'block'}}>
                          Uploading...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      </>
                    )}
                  </div>
                </Stack>
              </div>

              <div className='col-lg-6 mb-7 mt-5'>
                <TextField
                  fieldTitle={'First Name'}
                  filedTitleMandatory={true}
                  fieldName={'firstName'}
                  placeHolder={'Enter first name'}
                  maxLength={'20'}
                  handleOnChange={handleOnChange}
                  formik={formik}
                  disabled={isDisabled}
                  fieldValue={formik.getFieldMeta('firstName').value}
                />
              </div>

              <div className='col-lg-6 mb-7 mt-5'>
                <TextField
                  fieldTitle={'Last Name'}
                  filedTitleMandatory={false}
                  fieldName={'lastName'}
                  placeHolder={'Enter last name'}
                  maxLength={'20'}
                  handleOnChange={handleOnChange}
                  formik={formik}
                  disabled={isDisabled}
                  fieldValue={formik.getFieldMeta('lastName').value}
                />
              </div>

              <div className='col-lg-6 mb-7'>
                <TextField
                  fieldTitle={'Email ID'}
                  filedTitleMandatory={true}
                  fieldName={'emailId'}
                  placeHolder={'Enter email id'}
                  maxLength={'50'}
                  handleOnChange={handleOnChange}
                  formik={formik}
                  disabled={true}
                  fieldValue={formik.getFieldMeta('emailId').value}
                />
              </div>

              {userRole === 'System Admin' || userRole === 'QC User' ? (
                <div className='col-lg-6 mb-7'>
                  <TextField
                    fieldTitle={'System Admin Name'}
                    filedTitleMandatory={true}
                    fieldName={'teamName'}
                    placeHolder={'Enter system admin name'}
                    maxLength={'50'}
                    handleOnChange={handleOnChange}
                    formik={formik}
                    disabled={true}
                    fieldValue={formik.getFieldMeta('teamName').value}
                  />
                </div>
              ) : null}

              {userRole === 'Agent Admin' || userRole === 'Sales Admin' ? (
                <div className='col-lg-6 mb-7'>
                  <TextField
                    fieldTitle={'Sales Channel'}
                    filedTitleMandatory={true}
                    fieldName={'salesChannel'}
                    placeHolder={'Enter sales channel'}
                    maxLength={'50'}
                    handleOnChange={handleOnChange}
                    formik={formik}
                    disabled={true}
                    fieldValue={formik.getFieldMeta('salesChannel').value}
                  />
                </div>
              ) : null}

              <div
                className={`border-top d-flex flex-stack mt-10 pt-8 ${btnShow ? null : 'd-none'}`}
              >
                <div className='me-2'></div>
                <div className='d-flex'>
                  <button
                    type='reset'
                    onClick={() => handleDiscard()}
                    className='btn btn-light me-3'
                  >
                    Discard
                  </button>
                  <button
                    type='submit'
                    className={`btn btn-lg btn-primary ${urlLoading && isDisabled}`}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {editMode && <ResetPassword />}
    </>
  )
}

export default UserProfile
